import { getMSALInstance } from './msal-instance';
import { CONTEXT_KEY } from './api-constants';
import { removeUserFromRoom } from './statement-socket-client-api';
import { withDefaultContextAsHomeGeo } from './api-default-context';
import { handleLoginResponse } from './auth-helper';
import { getAPIClient } from 'api/api-common';

export const authenticateAcrossAllGeos = async () => {
  return authenticate(window.TIEOUT.ENV.CURRENT_GEO);
};

export const authenticate = async (geoKey) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    if (window !== window.parent) {
      return;
    }

    const tokenResponse = await handleLoginResponse(geoKey);
    const apiClientForGeo = getAPIClient(geoKey);

    if (apiClientForGeo.api)
      _authenticateAPI(
        apiClientForGeo,
        tokenResponse && tokenResponse.accessToken,
        () => {
          resolve();
        },
      );
  });
};

const _authenticateAPI = (apiClient, token, callback) => {
  if (!apiClient.flags.authenticated) {
    if (token) {
      apiClient.token = token;
      apiClient.flags.authenticated = true;
      callback();
    }
  }
};

// Handle authentication success
export const authenticateSuccess = () => {
  const msalInstance = getMSALInstance();
  msalInstance
    .handleRedirectPromise()
    .then(() => handleLoginResponse(window.TIEOUT.ENV.CURRENT_GEO));
};

export const clearAuthData = () => {
  sessionStorage.clear();
  // createAuthContext();
};

export const userLogOut = async (
  revisionId,
  projectUsersList,
  selectedProjectId,
) => {
  try {
    // This will verify if we are in statement page or any other page.
    // Any page other than statement page will not have revisionId and hence we do not want to make
    // removeUserFromRoom call for those pages.
    Number.isInteger(revisionId) &&
      projectUsersList &&
      (await removeUserFromRoom({
        revisionId,
        projectUserIds: Object.keys(projectUsersList),
        projectId: selectedProjectId,
      }));
    const geoKeys = Object.keys(window.TIEOUT.ENV.GEOS);
    for (let i = 0; i < geoKeys.length; i++) {
      await withDefaultContextAsHomeGeo({
        contextKey: CONTEXT_KEY.SELECTED_GEO_CONTEXT,
        contextValue: geoKeys[i],
      })
        .post('/logout', null, {
          headers: {
            'Content-Type': undefined,
          },
        })
        .catch((e) => console.error(e));
    }
  } catch (e) {
    console.debug(e);
  } finally {
    sessionStorage.clear();
  }
};

export const authContextLogout = () => {
  const msalInstance = getMSALInstance();
  msalInstance.logoutRedirect({
    account: msalInstance.getAllAccounts()[0],
  });
};
